<template>
	<VPopover
		:placement="placement"
		:popoverClass="popoverClass"
		:popoverArrowClass="popoverArrowClass"
		:popoverInnerClass="popoverInnerClass"
	>
		<!--Trigger open or close popoever -->
		<slot name="trigger"></slot>

		<!-- Content to display when popover is open -->
		<JBox class="s-cursor-pointer" slot="popover">
			<slot name="content"></slot>
		</JBox>
	</VPopover>
</template>

<script>
/** We are using v-tooltip from https://github.com/Akryum/v-tooltip#readme **/
export default {
	props: {
		placement: {
			type: String,
			default: () => "bottom-end"
		},
		popoverClass: {
			type: String,
			default: () => "s-w-48 s-rounded"
		},
		popoverArrowClass: {
			type: String,
			default: () => "s-w-0"
		},
		popoverInnerClass: {
			type: String,
			default: () => "s-w-full s-rounded s-bg-white s-border s-border-gray-300"
		}
	}
}
</script>
